<!-- components/FieldSelector.vue -->
<template>
  <div class="field-selector">
    <el-popover
        placement="bottom-end"
        width="400"
        trigger="click"
        :visible-arrow="false"
        v-model="popoverVisible"
    >
      <div class="field-selector-header">
        <span class="title">自定义列</span>
        <div class="actions">
          <el-button type="text" size="small" @click="selectAll">全选</el-button>
          <el-divider direction="vertical" />
          <el-button type="text" size="small" @click="deselectAll">清空</el-button>
          <el-divider direction="vertical" />
          <el-button type="text" size="small" @click="resetToDefault">重置</el-button>
        </div>
      </div>

      <div class="field-selector-body">
        <el-input
            v-model="searchKeyword"
            placeholder="搜索字段"
            size="small"
            prefix-icon="el-icon-search"
            clearable
            class="search-input"
        />

        <el-checkbox-group v-model="selectedFields" @change="handleChange">
          <div
              v-for="field in filteredFields"
              :key="field.key"
              class="field-item"
          >
            <el-checkbox :label="field.key" :disabled="field.disabled">
              {{ field.label }}
              <el-tooltip v-if="field.disabled" content="该字段不可隐藏" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>

      <div class="field-selector-footer">
        <el-button size="small" @click="popoverVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmSelection">确定</el-button>
      </div>

      <el-button
          slot="reference"
          type="text"
          icon="el-icon-s-operation"
          class="field-trigger"
      >
        自定义列
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import { Divider } from 'element-ui'

export default {
  name: 'FieldSelector',
  components: {
    'el-divider': Divider
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    defaultFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popoverVisible: false,
      searchKeyword: '',
      selectedFields: [...this.value]
    }
  },
  computed: {
    allFields() {
      return this.fields
    },
    filteredFields() {
      if (!this.searchKeyword) {
        return this.allFields
      }
      const keyword = this.searchKeyword.toLowerCase()
      return this.allFields.filter(field =>
          field.label.toLowerCase().includes(keyword) ||
          field.key.toLowerCase().includes(keyword)
      )
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selectedFields = [...val]
      },
      deep: true
    }
  },
  methods: {
    selectAll() {
      this.selectedFields = this.allFields.map(f => f.key)

      console.log(this.selectedFields)
    },
    deselectAll() {
      // 保留 disabled 的字段
      const disabledFields = this.allFields
          .filter(f => f.disabled)
          .map(f => f.key)
      this.selectedFields = disabledFields
    },
    resetToDefault() {
      this.selectedFields = [...this.defaultFields]
    },
    handleChange(value) {
      // 确保 disabled 字段始终被选中
      const disabledKeys = this.allFields
          .filter(f => f.disabled)
          .map(f => f.key)
      const missingDisabled = disabledKeys.filter(key => !this.selectedFields.includes(key))
      if (missingDisabled.length) {
        this.selectedFields = [...this.selectedFields, ...missingDisabled]
      }
      this.$emit('input', this.selectedFields)
      this.$emit('change', this.selectedFields)
    },
    confirmSelection() {
      this.popoverVisible = false
      this.$emit('confirm', this.selectedFields)
    }
  }
}
</script>

<style scoped>
.field-selector {
  display: inline-block;
}

.field-trigger {
  margin-left: 12px;
}

.field-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 12px;
}

.field-selector-header .title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.field-selector-header .actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-selector-body {
  max-height: 350px;
  overflow-y: auto;
}

.search-input {
  margin-bottom: 12px;
}

.field-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.field-item:last-child {
  border-bottom: none;
}

.field-selector-footer {
  padding-top: 12px;
  border-top: 1px solid #e4e7ed;
  margin-top: 12px;
  text-align: right;
}
</style>